<template>
  <div>
    <v-customer-inventory></v-customer-inventory>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
export default {
  name: "CustomerInventory",
  components: {
    VCustomerInventory: () =>
      import("../components/dashboard/CustomerInventory.vue"),
  },
  props: {},
  data() {
    return {
      portalId: 0,
      customerId: "",
      successMessage: "",
      errorMessage: "",
      customer: null,
    };
  },
  mounted() {
    console.log("customer");
    // var customerId = this.$route.params.id;
  },
  beforeDestroy() {},
  methods: {},
};
</script>

<style lang="css" scoped></style>
